module.exports = __webpack_public_path__ + "img/old3.2f0dcbe4.jpg";